module.exports = "<%=baseUrl%>/8fa12a459188502b9f0d39b8a67d9e6c.swf";